import { render } from "./Categories.vue?vue&type=template&id=1d6a1c5c&scoped=true"
import script from "../js/categories.js?vue&type=script&lang=js"
export * from "../js/categories.js?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=1d6a1c5c&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6a1c5c"]])

export default __exports__